module.exports = __webpack_public_path__ + "img/brand.621b312f.png";